import { EAction } from "../../types/enum";

type PlugNChargeGateInput = {
  /** Result of usePermission().user */
  permissions?: string[];
  /** Current value of the user's plug_n_charge_enabled flag */
  enabled: boolean;
  vehicleLicensePlate?: string;
  isDeleted?: boolean;
};

/**
 * NDT-1511: shared gate for the Plug & Charge toggle, used by both the user list and the
 * user detail page so the rules and the copy stay in one place.
 *
 * Returns "" when toggling is allowed, otherwise the reason to show the admin. Plug & Charge
 * identifies a driver by their car plate, so enabling it for a user with no plate on file
 * would create a toggle that can never actually fire. Turning it *off* is always permitted
 * (given permission), so an admin is never stuck with it on.
 */
export const getPlugNChargeBlockedReason = ({
  permissions,
  enabled,
  vehicleLicensePlate,
  isDeleted,
}: PlugNChargeGateInput): string => {
  if (!permissions?.includes(EAction.UPDATE)) {
    return "You do not have permission to change this.";
  }

  if (isDeleted) {
    return "This user is deleted.";
  }

  if (!vehicleLicensePlate && !enabled) {
    return "Add a car plate first — Plug & Charge identifies the driver by plate.";
  }

  return "";
};
